module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"title":"Фильтр","reset-all":"Сбросить все"}}')
  delete Component.options._Ctor
}
